"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import FAQAccordion, { type FAQItem } from "@/components/unis/FAQAccordion";
import HoverArrow from "@/components/shared/HoverArrow";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export default function UniDetailFAQ({
  uniName,
  faqs,
}: {
  uniName: string;
  faqs: FAQItem[];
}) {
  return (
    <section className="cv-auto bg-paper border-t border-line py-20 lg:py-24" aria-labelledby="uni-faq-heading">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={stagger(0.09)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="flex flex-col gap-5 mb-12"
        >
          <motion.p
            variants={fadeUp}
            className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-ink-faint"
          >
            <span className="w-1.5 h-1.5 bg-accent shrink-0" aria-hidden="true" />
            FAQ
          </motion.p>
          <motion.h2
            variants={fadeUp}
            id="uni-faq-heading"
            className="font-display font-bold text-3xl sm:text-4xl tracking-tight leading-[1.1] text-ink"
          >
            Häufige Fragen zur {uniName}
          </motion.h2>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <FAQAccordion faqs={faqs} />
          <Link
            href="/faq/"
            className="inline-flex items-center gap-2 mt-8 text-sm font-semibold text-accent hover:text-accent-deep transition-colors duration-200 group cursor-pointer"
          >
            Alle Fragen ansehen
            <HoverArrow size={15} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
